export const seriesItems = [
  {
    id: 'series-01',
    category: 'tv',
    title: '城中之城',
    subtitle: 'City Within',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '都市'],
    rating: 8.3,
    director: '沈峻',
    cast: ['于和风', '刘诗曼', '赵铭'],
    duration: '全36集',
    popularity: 96,
    summary: '一座新城拔地而起，规划局、开发商与老住户在图纸上反复拉锯。',
    synopsis:
      '滨海新区启动十年最大规模的城市更新，一块老城区被划入核心商务区。规划局年轻科员于澄被派去做拆迁协调，开发商、原住民与政府部门各执一词。一张规划图纸改了四十七稿，每一稿背后都是一个家庭的具体生活。城市在长高，人却要重新学会怎么住在一起。',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20poster%20artwork%2C%20blueprint%20and%20aerial%20city%20skyline%20merging%2C%20a%20young%20planner%20looking%20up%20at%20construction%20cranes%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20dusk%20view%20of%20a%20rapidly%20growing%20Chinese%20city%2C%20construction%20cranes%20against%20deep%20blue%20sky%2C%20warm%20amber%20windows%20in%20new%20towers%2C%20old%20low-rise%20neighborhood%20in%20foreground%2C%20no%20text&width=1600&height=900&seq=hero-series-01&orientation=landscape',
  },
  {
    id: 'series-02',
    category: 'tv',
    title: '潮汐之上',
    subtitle: 'Above the Tide',
    year: 2026,
    region: '中国大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.9,
    director: '顾长宁',
    cast: ['秦海', '叶疏影', '罗晋川'],
    duration: '全24集',
    popularity: 97,
    featured: true,
    summary: '一座跨海大桥合龙当天，失踪二十年的工程师图纸被人放回了指挥部。',
    synopsis:
      '跨海大桥合龙在即，总工程师秦海在办公桌上发现一卷二十年前的原始图纸，署名是当年在事故中失踪的前任总工。图纸上标注的每一处修改，都精确预言了这二十年里发生的意外。秦海一边追查图纸的来源，一边发现整个工程都建立在一个被刻意抹去的真相之上。',
    poster:
      'https://readdy.ai/api/search-image?query=Suspense%20drama%20poster%20artwork%2C%20a%20lone%20engineer%20standing%20on%20an%20unfinished%20sea%20bridge%20at%20night%2C%20old%20rolled%20blueprints%20in%20hand%2C%20deep%20blue%20sea%20and%20amber%20work%20lights%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Unfinished%20cross-sea%20bridge%20at%20blue%20hour%2C%20warm%20amber%20construction%20lights%20along%20the%20deck%2C%20deep%20dark%20blue%20ocean%20and%20mist%2C%20cinematic%20suspense%20series%20still%2C%20no%20text&width=1600&height=900&seq=hero-series-02&orientation=landscape',
  },
  {
    id: 'series-03',
    category: 'tv',
    title: '长街灯火',
    subtitle: 'Lights on the Long Street',
    year: 2024,
    region: '中国大陆',
    genres: ['年代', '家庭'],
    rating: 8.8,
    director: '孔祥',
    cast: ['萨日娜', '王志远', '李念'],
    duration: '全42集',
    popularity: 88,
    summary: '一条老街上五户人家，四十年里守着一口共用的大灶和彼此的日子。',
    synopsis:
      '从八十年代到现在，北方老城的长街一号院住了五户人家。院里有一口公用大灶，谁家做了好吃的都要分一碗。四十年间，工厂改制、子女远行、老屋拆迁，院墙被推倒又重新垒起。到最后留下的那盏灯，照着的已经不只是这条街。',
    poster:
      'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20family%20drama%20poster%20artwork%2C%20a%20warm%20courtyard%20with%20steam%20rising%20from%20a%20shared%20outdoor%20stove%20at%20dusk%2C%20old%20brick%20walls%20and%20paper%20lanterns%2C%20amber%20glow%20against%20deep%20blue%20evening%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-03&orientation=portrait',
  },
  {
    id: 'series-04',
    category: 'tv',
    title: '破晓行动',
    subtitle: 'Operation Daybreak',
    year: 2025,
    region: '中国大陆',
    genres: ['刑侦', '动作'],
    rating: 8.2,
    director: '徐铁',
    cast: ['何振宇', '林晓棠', '马骁'],
    duration: '全32集',
    popularity: 90,
    summary: '一支临时组建的缉毒小组，在边境线上与时间赛跑了九十天。',
    synopsis:
      '边境城市连续出现新型毒品，警方从三个单位抽调人员组成临时专案组，代号「破晓」。组长何振宇带着一群各有心结的队员，从一条废弃的运输线查到城里的物流仓库。九十天限期，每一次收网都差一步，而他们逐渐意识到，泄密的人可能就在专案组内部。',
    poster:
      'https://readdy.ai/api/search-image?query=Police%20action%20series%20poster%20artwork%2C%20tactical%20team%20silhouettes%20moving%20through%20a%20container%20yard%20at%20dawn%2C%20blue%20pre-dawn%20light%20and%20orange%20flare%2C%20tense%20composition%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-04&orientation=portrait',
  },
  {
    id: 'series-05',
    category: 'tv',
    title: '我的合租室友是外星人',
    subtitle: 'My Roommate Is an Alien',
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '科幻'],
    rating: 7.9,
    director: '白川',
    cast: ['周可儿', '徐一航', '段小飞'],
    duration: '全24集',
    popularity: 85,
    summary: '她只是想找个便宜室友，没想到对方是来地球做市场调研的外星观察员。',
    synopsis:
      '刚毕业的周可儿为了分摊房租，在网上发了一条合租帖。应征者是一位举止古怪、坚持要用硬币付水电费的年轻人。她很快发现，这位室友是来自外星的初级观察员，任务是写一份关于「人类为什么要合租」的调研报告。两个人一边适应彼此的生活习惯，一边把这份报告写得越来越不像报告。',
    poster:
      'https://readdy.ai/api/search-image?query=Playful%20sci-fi%20comedy%20series%20poster%20artwork%2C%20two%20young%20roommates%20in%20a%20messy%20apartment%2C%20one%20with%20a%20subtle%20glowing%20aura%20and%20antenna%20shadow%2C%20warm%20amber%20lamplight%20and%20cool%20teal%20night%20window%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-05&orientation=portrait',
  },
  {
    id: 'series-06',
    category: 'tv',
    title: '城南旧案',
    subtitle: 'Old Cases of the South City',
    year: 2023,
    region: '中国大陆',
    genres: ['悬疑', '犯罪'],
    rating: 8.6,
    director: '程岩',
    cast: ['李崇', '吴雪', '张培'],
    duration: '全28集',
    popularity: 84,
    summary: '一位即将退休的老刑警，决定在离开前把抽屉里三桩旧案一起了结。',
    synopsis:
      '老刑警李崇还有三个月退休。他的抽屉里放着三桩没有结案的卷宗，最早的一桩已经过去二十六年。他找来刚入警校实习的外甥女帮忙整理，两人按着当年的走访笔记重新跑了一遍城南。时间改变了街巷，却没能改变某些人的说法，而所有线索最终指向同一个夏天的傍晚。',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20crime%20mystery%20series%20poster%20artwork%2C%20an%20older%20detective%20in%20a%20raincoat%20standing%20in%20an%20old%20southern%20city%20alley%2C%20stack%20of%20faded%20case%20files%2C%20teal%20shadows%20and%20amber%20streetlight%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-06&orientation=portrait',
  },
  {
    id: 'series-07',
    category: 'tv',
    title: '白衣渡江',
    subtitle: 'Crossing the River in White',
    year: 2026,
    region: '中国大陆',
    genres: ['古装', '历史'],
    rating: 8.7,
    director: '张牧之',
    cast: ['谢云舟', '苏锦', '裴徵'],
    duration: '全40集',
    popularity: 94,
    featured: true,
    summary: '一介寒门医官，凭一册残卷在乱世里救下了一座城的百姓。',
    synopsis:
      '南渡之后，江北疫病横行，朝廷派不出足够的医官。寒门出身的医者谢云舟带着一册残缺的《渡江方》，独自北上入城。他要面对的不只是疫病，还有封锁城门的军令、囤积药材的世家，以及一份被人故意改错的药方。一袭白衣，成了这座城最后的指望。',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20artwork%2C%20a%20scholar%20physician%20in%20white%20robes%20standing%20on%20a%20misty%20riverbank%2C%20ancient%20city%20walls%20and%20banners%2C%20ink%20blue%20tones%20with%20warm%20amber%20lantern%20glow%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Misty%20ancient%20Chinese%20river%20crossing%20at%20dawn%2C%20stone%20city%20wall%20and%20faded%20banners%2C%20a%20lone%20figure%20in%20white%20robes%20on%20a%20ferry%2C%20ink%20blue%20atmosphere%20with%20amber%20lanterns%2C%20no%20text&width=1600&height=900&seq=hero-series-07&orientation=landscape',
  },
  {
    id: 'series-08',
    category: 'tv',
    title: '山海食堂',
    subtitle: 'Mountain and Sea Kitchen',
    year: 2025,
    region: '中国大陆',
    genres: ['治愈', '美食'],
    rating: 8.9,
    director: '林家禾',
    cast: ['顾南', '唐糖', '老赵'],
    duration: '全20集',
    popularity: 87,
    summary: '公路边的一间小食堂，每天只做三桌菜，听三桌人的故事。',
    synopsis:
      '国道边上有一间没有招牌的小食堂，老板顾南每天只接待三桌客人，菜单写在门口的木板上。跑长途的司机、赶着回家的年轻人、吵完架的夫妻都会在这里坐下来吃一顿。他不劝人，只做菜。一集一个故事，一集一道菜，山海之间，热气腾腾。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20healing%20food%20drama%20poster%20artwork%2C%20a%20small%20roadside%20kitchen%20with%20steaming%20dishes%20on%20a%20wooden%20table%2C%20mountains%20and%20sea%20visible%20through%20the%20window%2C%20amber%20lantern%20light%20and%20dusk%20blue%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-08&orientation=portrait',
  },
  {
    id: 'series-09',
    category: 'tv',
    title: '逆风翻盘',
    subtitle: 'Against the Wind',
    year: 2024,
    region: '中国大陆',
    genres: ['体育', '青春'],
    rating: 7.8,
    director: '韩冬',
    cast: ['吴一舟', '沈星', '赵大鹏'],
    duration: '全30集',
    popularity: 82,
    summary: '一支被解散三年的校队，靠一个不肯认输的教练重新站上赛场。',
    synopsis:
      '市里最差的中学排球队三年前被解散，场地改成了仓库。新来的体育老师吴一舟想把它重新组起来，招来的队员有的是被其他队淘汰的，有的根本没打过球。从捡球开始，从输掉每一场热身赛开始，他们用一年时间，把「不可能赢」打成了「再拼一局」。',
    poster:
      'https://readdy.ai/api/search-image?query=Youth%20sports%20drama%20poster%20artwork%2C%20high%20school%20volleyball%20team%20in%20a%20dim%20gym%2C%20one%20player%20diving%20for%20the%20ball%2C%20dust%20in%20a%20shaft%20of%20amber%20light%20against%20deep%20blue%20shadows%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-09&orientation=portrait',
  },
  {
    id: 'series-10',
    category: 'tv',
    title: '山海之间',
    subtitle: 'Between Mountain and Sea',
    year: 2022,
    region: '中国大陆',
    genres: ['剧情', '乡村'],
    rating: 8.5,
    director: '田卫国',
    cast: ['刘长河', '杨采薇', '何小军'],
    duration: '全26集',
    popularity: 65,
    summary: '返乡的年轻兽医，用三年时间让一个空心村重新有了孩子的笑声。',
    synopsis:
      '在城市做了五年宠物医生的杨采薇回到山里老家，发现村里只剩下老人和一条狗。她留下来开了间兽医站，从给牛接生开始，慢慢把散养的农户组织起来。修路、通网、办合作社，一件件小事磨掉了她的急躁，也让离开的人开始往回走。',
    poster:
      'https://readdy.ai/api/search-image?query=Rural%20Chinese%20drama%20poster%20artwork%2C%20terraced%20mountain%20village%20in%20morning%20mist%2C%20a%20young%20veterinarian%20walking%20with%20a%20dog%20along%20a%20field%20path%2C%20green%20hills%20and%20warm%20amber%20sunrise%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-10&orientation=portrait',
  },
  {
    id: 'series-11',
    category: 'tv',
    title: '不眠之证',
    subtitle: 'Sleepless Evidence',
    year: 2026,
    region: '中国大陆',
    genres: ['悬疑', '心理'],
    rating: 8.4,
    director: '严肃',
    cast: ['邵清', '陆遥', '程可'],
    duration: '全24集',
    popularity: 91,
    summary: '连续四十天无法入睡的犯罪心理顾问，开始分不清梦境与卷宗。',
    synopsis:
      '犯罪心理顾问邵清接手一宗连环案后，开始严重失眠。她能记住卷宗里的每一个细节，却渐渐分不清哪些是现场照片，哪些是自己梦里见过的画面。当她根据「记忆」找到一处关键地点时，所有证据都显示她从未来过这里。是案件找上了她，还是她在案件里留下了什么。',
    poster:
      'https://readdy.ai/api/search-image?query=Psychological%20thriller%20series%20poster%20artwork%2C%20exhausted%20woman%20staring%20at%20a%20wall%20of%20case%20photos%2C%20harsh%20window%20light%20and%20deep%20blue%20shadows%2C%20slightly%20unsettling%20atmosphere%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-11&orientation=portrait',
  },
  {
    id: 'series-12',
    category: 'tv',
    title: '深海边缘',
    subtitle: 'Edge of the Deep',
    year: 2025,
    region: '美国',
    genres: ['科幻', '惊悚'],
    rating: 8.6,
    director: 'Marcus Vale',
    cast: ['Erin Blake', 'Jonah Reed', 'Talia Moss'],
    duration: '全8集',
    popularity: 93,
    featured: true,
    summary: '深海钻井平台失去联系七十二小时，救援队下潜后听见了平台的心跳声。',
    synopsis:
      '北大西洋一座深海钻井平台突然中断所有通讯。救援小队下潜至四千米深处，发现平台结构完好，人员却全部消失。更奇怪的是，声呐持续捕捉到一种规律的震动，像心跳，也像某种回应。随着氧气储量下降，队员们开始怀疑，平台并不是出事了，而是被「邀请」到了别处。',
    poster:
      'https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20thriller%20poster%20artwork%2C%20an%20underwater%20drilling%20platform%20silhouetted%20against%20a%20faint%20blue%20abyss%2C%20diver%20with%20a%20flashlight%2C%20bioluminescent%20particles%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20with%20an%20enormous%20offshore%20platform%20structure%20descending%20into%20darkness%2C%20faint%20teal%20light%20and%20diver%20beams%2C%20cinematic%20sci-fi%20underwater%20scene%2C%20no%20text&width=1600&height=900&seq=hero-series-12&orientation=landscape',
  },
  {
    id: 'series-13',
    category: 'tv',
    title: '曼哈顿公寓',
    subtitle: 'The Manhattan Apartment',
    year: 2024,
    region: '美国',
    genres: ['剧情', '悬疑'],
    rating: 8.1,
    director: 'Laura Grant',
    cast: ['Mia Chen', 'Adrian Cross', 'Ruth Adler'],
    duration: '全10集',
    popularity: 80,
    summary: '一栋老牌公寓的十二户邻居，共同保守着顶楼那扇不开的门。',
    synopsis:
      '曼哈顿上西区一栋战前公寓，住户们维持着一种默契：顶楼那户从不打开的门，谁也不提。新搬来的租客米娅在一次停电中误入顶楼，看见了一间按三十年前原样布置的房间。她开始向邻居打听，每个人都给出不同的说法，而每一个说法里，都有人希望她停止追问。',
    poster:
      'https://readdy.ai/api/search-image?query=Manhattan%20apartment%20mystery%20series%20poster%20artwork%2C%20an%20old%20prewar%20building%20facade%20at%20night%2C%20one%20dark%20unlit%20window%20at%20the%20top%2C%20warm%20amber%20streetlight%20and%20deep%20blue%20shadows%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-13&orientation=portrait',
  },
  {
    id: 'series-14',
    category: 'tv',
    title: '断裂点',
    subtitle: 'Breaking Point',
    year: 2023,
    region: '美国',
    genres: ['犯罪', '律政'],
    rating: 8.4,
    director: 'Greg Sanders',
    cast: ['Nina Cole', 'Mark Ellis', 'Devon Ray'],
    duration: '全12集',
    popularity: 79,
    summary: '一名公设辩护人，在连续三起案件里看见了同一份被涂改的证词。',
    synopsis:
      '公设辩护人尼娜每天要处理十几个案子，直到她发现三份来自不同案件的证词，措辞结构几乎一模一样。她开始怀疑有人在系统性地制造「标准证人」。随着调查推进，她面对的已经不只是某个案子，而是整条从取证到审判的链条。',
    poster:
      'https://readdy.ai/api/search-image?query=Legal%20crime%20series%20poster%20artwork%2C%20a%20female%20public%20defender%20holding%20a%20thick%20case%20file%20outside%20a%20courthouse%20at%20dusk%2C%20stone%20columns%20and%20cold%20blue%20light%20with%20amber%20lamps%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-14&orientation=portrait',
  },
  {
    id: 'series-15',
    category: 'tv',
    title: '荒野档案',
    subtitle: 'Wilderness Files',
    year: 2022,
    region: '美国',
    genres: ['冒险', '纪实'],
    rating: 8.7,
    director: 'Ben Hollis',
    cast: ['Cody Lane', 'Sara Quinn', 'Will Foster'],
    duration: '全6集',
    popularity: 62,
    summary: '六位野外摄影师，用一年时间记录北美最后一片无路之地。',
    synopsis:
      '一支六人摄影团队深入北美仅存的无路荒野，用四季时间记录这里的迁徙、捕食与消长。他们要面对的不只是极端天气，还有设备故障、补给延误和彼此的摩擦。镜头里没有旁白，只有雪地上的脚印、夜里靠近营地的呼吸声，以及自然本身缓慢而坚定的秩序。',
    poster:
      'https://readdy.ai/api/search-image?query=Wilderness%20documentary%20poster%20artwork%2C%20a%20lone%20photographer%20with%20a%20telephoto%20lens%20on%20a%20ridge%20at%20sunrise%2C%20vast%20pine%20forest%20and%20mist%2C%20cool%20teal%20shadows%20with%20warm%20amber%20light%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-15&orientation=portrait',
  },
  {
    id: 'series-16',
    category: 'tv',
    title: '西部残阳',
    subtitle: 'Western Afterglow',
    year: 2021,
    region: '美国',
    genres: ['西部', '剧情'],
    rating: 8.2,
    director: 'Hank Rivera',
    cast: ['Cole Barrett', 'June Avery', 'Silas Ward'],
    duration: '全9集',
    popularity: 58,
    summary: '铁路修到小镇的那一年，最后的赏金猎人决定放下枪。',
    synopsis:
      '1889 年，铁路即将穿过西部小镇，旧日的秩序正在退场。赏金猎人科尔完成最后一单委托，准备把枪卖掉换一块地。可他押送的犯人在途中被劫走，镇上所有人都希望他再追一次。残阳下的小镇，枪声与汽笛声同时响起。',
    poster:
      'https://readdy.ai/api/search-image?query=Western%20series%20poster%20artwork%2C%20a%20weathered%20bounty%20hunter%20on%20horseback%20silhouetted%20against%20a%20burning%20orange%20desert%20sunset%2C%20dusty%20town%20in%20the%20distance%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-16&orientation=portrait',
  },
  {
    id: 'series-17',
    category: 'tv',
    title: '王冠之下',
    subtitle: 'Beneath the Crown',
    year: 2025,
    region: '英国',
    genres: ['历史', '剧情'],
    rating: 8.8,
    director: 'Harriet Doyle',
    cast: ['Eleanor Price', 'James Ashford', 'Olivia Kent'],
    duration: '全10集',
    popularity: 86,
    summary: '一座古堡的管家回忆录，写下了王冠背后无人知晓的四十年。',
    synopsis:
      '古堡的退休管家在晚年写下一本回忆录，记录他从十六岁进城堡起，亲历的四十年。书中没有惊天动地的政治事件，只有宴会前夜的争执、走廊里压低的声音，以及那些被礼仪包裹的真实情绪。当回忆录的手稿流出，很多被写进历史书的细节，第一次有了另一种版本。',
    poster:
      'https://readdy.ai/api/search-image?query=British%20historical%20drama%20poster%20artwork%2C%20a%20stately%20stone%20castle%20corridor%20with%20portraits%20and%20candlelight%2C%20a%20butler%20silhouette%20holding%20a%20silver%20tray%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-17&orientation=portrait',
  },
  {
    id: 'series-18',
    category: 'tv',
    title: '雾都谜案',
    subtitle: 'Mysteries of the Fog City',
    year: 2024,
    region: '英国',
    genres: ['悬疑', '犯罪'],
    rating: 8.5,
    director: 'Rupert Blake',
    cast: ['Alice Moore', 'Thomas Hale', 'Ivy Shaw'],
    duration: '全8集',
    popularity: 83,
    summary: '维多利亚时代的伦敦，一位女法医在浓雾中追查连环失踪案。',
    synopsis:
      '1891 年的伦敦东区，连续有人在浓雾夜失踪。警局束手无策，一位被排除在解剖室之外的女法医爱丽丝，靠着自己的笔记和几位街头熟人展开调查。她发现所有失踪者都曾在同一家慈善药房取药，而那家药房背后，站着一位颇有名望的绅士。',
    poster:
      'https://readdy.ai/api/search-image?query=Victorian%20London%20mystery%20series%20poster%20artwork%2C%20a%20woman%20in%20a%20dark%20cloak%20holding%20a%20lantern%20in%20a%20foggy%20cobblestone%20street%2C%20gaslight%20and%20silhouetted%20carriages%2C%20deep%20blue%20and%20amber%20tones%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-18&orientation=portrait',
  },
  {
    id: 'series-19',
    category: 'tv',
    title: '唐顿的夏天',
    subtitle: 'Summer at Downton',
    year: 2023,
    region: '英国',
    genres: ['剧情', '家庭'],
    rating: 8.3,
    director: 'Fiona Clarke',
    cast: ['Margaret Bell', 'Henry Lowell', 'Rose Fletcher'],
    duration: '全8集',
    popularity: 69,
    summary: '一个庄园的最后一个夏天，楼上楼下的人都在准备各自的告别。',
    synopsis:
      '乡间庄园因遗产税即将出售，这是它作为私人住宅的最后一个夏天。庄园主一家与仆人们都在悄悄安排往后的人生：有人打算进城，有人准备留下做管理员，还有人想把花园重新种一遍。一场夏末的园游会，成了所有人好好说再见的机会。',
    poster:
      'https://readdy.ai/api/search-image?query=English%20country%20estate%20drama%20poster%20artwork%2C%20a%20grand%20manor%20house%20with%20a%20lavish%20summer%20garden%20party%2C%20white%20linen%20tables%20and%20rose%20arches%2C%20warm%20golden%20light%20with%20soft%20green%20shadows%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-19&orientation=portrait',
  },
  {
    id: 'series-20',
    category: 'tv',
    title: '北欧回声',
    subtitle: 'Nordic Echo',
    year: 2026,
    region: '英国',
    genres: ['科幻', '悬疑'],
    rating: 8.7,
    director: 'Lars Whitmore',
    cast: ['Freya Lund', 'Owen Marsh', 'Ingrid Vale'],
    duration: '全6集',
    popularity: 85,
    summary: '极圈内的射电望远镜收到一段回声，内容是一周后才会发生的新闻。',
    synopsis:
      '挪威北部的射电望远镜阵列接收一段异常信号，解码后是一则完整的新闻播报，日期在七天之后。研究团队一开始当作恶作剧，直到新闻里的第一件事如期发生。他们必须在下一段信号到来前，弄清楚这到底是预言、延迟，还是有人在对他们进行一场精密的广播。',
    poster:
      'https://readdy.ai/api/search-image?query=Nordic%20sci-fi%20mystery%20poster%20artwork%2C%20radio%20telescope%20dishes%20in%20a%20snowy%20arctic%20landscape%20under%20green%20aurora%2C%20deep%20blue%20night%20and%20cold%20white%20snow%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-20&orientation=portrait',
  },
  {
    id: 'series-21',
    category: 'tv',
    title: '东京一人食',
    subtitle: 'Tokyo Table for One',
    year: 2025,
    region: '日本',
    genres: ['治愈', '生活'],
    rating: 8.9,
    director: '小林修司',
    cast: ['吉田绫', '高桥健', '中村梅'],
    duration: '全12集',
    popularity: 81,
    summary: '一个总在加班的女生，用每天的二十分钟认真吃完一顿饭。',
    synopsis:
      '在东京做广告的绫，每天下班都已近十点。她给自己定了一个规矩：无论多晚，都要坐下来好好吃一顿饭。一间小馆、一碗面、一份关东煮，她在每一集里遇见不同的店主和邻座，也慢慢把被工作挤压的生活，一点点吃回来了。',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20slice-of-life%20series%20poster%20artwork%2C%20a%20young%20woman%20eating%20alone%20at%20a%20small%20wooden%20counter%20in%20a%20tiny%20Tokyo%20eatery%2C%20steam%20and%20warm%20amber%20lamplight%2C%20deep%20blue%20night%20outside%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-21&orientation=portrait',
  },
  {
    id: 'series-22',
    category: 'tv',
    title: '无声的雨',
    subtitle: 'Silent Rain',
    year: 2024,
    region: '日本',
    genres: ['悬疑', '剧情'],
    rating: 8.2,
    director: '大野诚',
    cast: ['宫本纱', '石田航', '藤井真'],
    duration: '全10集',
    popularity: 74,
    summary: '一场持续四十天的大雨，把一个镇子所有人的口供冲得对不上。',
    synopsis:
      '山间小镇连续下了四十天雨，一名中学教师在雨夜里失踪。警方走访了全镇，每个人的叙述都有一点对不上。有人记错了时间，有人说谎，也有人只是不敢说自己看见了什么。雨停的那天，水库放水，冲出了一件不属于任何失踪者的东西。',
    poster:
      'https://readdy.ai/api/search-image?query=Japanese%20mystery%20series%20poster%20artwork%2C%20a%20rain-soaked%20small%20town%20street%20at%20night%2C%20a%20single%20umbrella%20walking%20away%2C%20deep%20teal%20blue%20and%20amber%20vending%20machine%20glow%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-22&orientation=portrait',
  },
  {
    id: 'series-23',
    category: 'tv',
    title: '首尔月光',
    subtitle: 'Seoul Moonlight',
    year: 2026,
    region: '韩国',
    genres: ['爱情', '都市'],
    rating: 8.0,
    director: '朴智勋',
    cast: ['李瑞妍', '金道贤', '崔恩'],
    duration: '全16集',
    popularity: 89,
    summary: '两个总在同一班末班地铁上遇见的人，用一年时间才说出一句你好。',
    synopsis:
      '在首尔，广告策划李瑞妍每天赶末班地铁回家，总能在同一节车厢遇见同一个男人。他们从不交谈，只在对方睡着时帮忙看着包。一年里，车厢外的城市不断变化，他们的生活也各自经历分手、失业和搬家。直到某天末班车停运，两人才第一次并肩走出站台。',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20urban%20romance%20series%20poster%20artwork%2C%20two%20people%20sitting%20apart%20in%20a%20late-night%20subway%20carriage%2C%20moonlight%20through%20the%20windows%2C%20warm%20amber%20interior%20light%20and%20deep%20blue%20night%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-23&orientation=portrait',
  },
  {
    id: 'series-24',
    category: 'tv',
    title: '猎犬',
    subtitle: 'The Hounds',
    year: 2023,
    region: '韩国',
    genres: ['动作', '犯罪'],
    rating: 8.4,
    director: '金泰勇',
    cast: ['马东锡根', '徐河俊', '李彩英'],
    duration: '全8集',
    popularity: 87,
    summary: '两个退役拳手转行做私人安保，接下一单保护证人的活儿。',
    synopsis:
      '退役拳手基勋和昌宇合伙开了一家小安保公司，接的多是找猫找狗的活儿。一天，一位律师带着一名即将出庭的证人上门，请他们保护证人两周。酬劳高得不正常，麻烦也来得比预想快。两个人只能用拳头和一点运气，把证人送进法庭。',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20action%20crime%20series%20poster%20artwork%2C%20two%20broad-shouldered%20men%20in%20black%20jackets%20standing%20in%20a%20narrow%20neon-lit%20alley%2C%20rain%20and%20steam%2C%20cold%20blue%20with%20orange%20neon%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-24&orientation=portrait',
  },
  {
    id: 'series-25',
    category: 'tv',
    title: '双面律师',
    subtitle: 'The Double Counsel',
    year: 2025,
    region: '韩国',
    genres: ['律政', '悬疑'],
    rating: 8.3,
    director: '尹尚民',
    cast: ['郑恩彩', '朴时厚', '韩智元'],
    duration: '全16集',
    popularity: 83,
    summary: '同一个律师，白天为财阀辩护，晚上替受害者写诉状。',
    synopsis:
      '大律所的王牌律师郑恩彩白天替财阀打官司，晚上则用另一个身份为普通人写诉状。她原本把两条线分得很清楚，直到一桩工伤案里，原告丈夫正是她白天的客户。两个身份在同一个法庭上正面相撞，她必须决定，这一次用哪个名字站起来。',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20legal%20thriller%20series%20poster%20artwork%2C%20a%20female%20lawyer%20split%20between%20a%20glass%20tower%20office%20and%20a%20dim%20street%20at%20night%2C%20her%20reflection%20doubled%2C%20deep%20blue%20and%20amber%20contrast%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-25&orientation=portrait',
  },
  {
    id: 'series-26',
    category: 'tv',
    title: '塞纳河左岸',
    subtitle: 'Left Bank',
    year: 2022,
    region: '法国',
    genres: ['爱情', '剧情'],
    rating: 8.1,
    director: 'Juliette Moreau',
    cast: ['Manon Girard', 'Baptiste Roux', 'Claire Petit'],
    duration: '全8集',
    popularity: 60,
    summary: '一家左岸旧书店的继承之争，牵出两代人没寄出的情书。',
    synopsis:
      '塞纳河左岸的一家旧书店老板去世，留下遗嘱：书店由女儿和一位陌生年轻人共同继承。两人在整理库存时，发现了一箱从未寄出的情书，收信人分别是他们各自的父母。为了弄清这段被藏了三十年的关系，他们开始按信封上的地址，一封一封地送。',
    poster:
      'https://readdy.ai/api/search-image?query=Parisian%20romantic%20drama%20series%20poster%20artwork%2C%20a%20small%20left-bank%20bookshop%20with%20warm%20glowing%20windows%20at%20dusk%2C%20stacked%20old%20books%20and%20letters%2C%20deep%20blue%20twilight%20over%20the%20Seine%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-26&orientation=portrait',
  },
  {
    id: 'series-27',
    category: 'tv',
    title: '新德里日记',
    subtitle: 'New Delhi Diaries',
    year: 2024,
    region: '印度',
    genres: ['剧情', '家庭'],
    rating: 8.2,
    director: 'Priya Sharma',
    cast: ['Anika Rao', 'Vikram Singh', 'Dev Patel'],
    duration: '全10集',
    popularity: 64,
    summary: '一个三代同堂的德里家庭，在一年里办了三场婚礼和一场葬礼。',
    synopsis:
      '德里老城区的一户人家，三代人挤在一栋三层小楼里。大女儿的婚事刚定，二儿子又带回了不同种姓的女友，祖母则坚持要按老规矩办每一场仪式。一年里，这个家庭经历了三场婚礼和一场葬礼，也在争吵与和解中，慢慢学会了怎么让彼此都好过一点。',
    poster:
      'https://readdy.ai/api/search-image?query=Indian%20family%20drama%20series%20poster%20artwork%2C%20a%20three-story%20Delhi%20home%20with%20marigold%20garlands%20and%20warm%20string%20lights%2C%20family%20silhouettes%20on%20the%20rooftop%2C%20amber%20and%20deep%20indigo%20palette%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-27&orientation=portrait',
  },
  {
    id: 'series-28',
    category: 'tv',
    title: '极地观测站',
    subtitle: 'Polar Station',
    year: 2026,
    region: '美国',
    genres: ['科幻', '悬疑'],
    rating: 8.8,
    director: 'Nora Vance',
    cast: ['Ruth Calder', 'Miles Dunn', 'Ike Sawyer'],
    duration: '全8集',
    popularity: 92,
    summary: '极夜里，观测站的人数比名单上多了一个，没人知道多的是谁。',
    synopsis:
      '南极观测站进入为期六个月的极夜，站内有八名科考人员。第三周，厨师在清点餐盘时发现，每天实际用餐的有九个人。所有人都在，所有房间都登记在册，却没有人能说清多出来的那一个是谁。极夜还很长，恐慌比寒冷更快地渗进每个人心里。',
    poster:
      'https://readdy.ai/api/search-image?query=Antarctic%20research%20station%20horror%20poster%20artwork%2C%20a%20snow-covered%20module%20base%20glowing%20amber%20under%20polar%20night%2C%20a%20shadowed%20figure%20standing%20in%20the%20snow%20outside%2C%20deep%20blue%20darkness%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-28&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Antarctic%20research%20station%20in%20polar%20night%2C%20warm%20amber%20windows%20in%20a%20frozen%20landscape%2C%20deep%20blue%20snow%20and%20faint%20aurora%2C%20cinematic%20isolation%2C%20no%20text&width=1600&height=900&seq=hero-series-28&orientation=landscape',
  },
  {
    id: 'series-29',
    category: 'tv',
    title: '潮汐档案',
    subtitle: 'Tidal Files',
    year: 2025,
    region: '中国香港',
    genres: ['悬疑', '犯罪'],
    rating: 8.3,
    director: '何镇东',
    cast: ['方中信宇', '陈静', '李柏豪'],
    duration: '全20集',
    popularity: 78,
    summary: '每当大潮退去，海边的礁石缝里就会出现一只装着档案的防水箱。',
    synopsis:
      '海边的老警员在退潮后捡到一只防水箱，里面装着二十年前一宗走私案的完整证据。此后每逢大潮，都会有新的箱子出现，内容一次比一次接近真相。警方成立专案组追查投递者，而所有线索都指向一名早已被宣告死亡的海关调查员。',
    poster:
      'https://readdy.ai/api/search-image?query=Hong%20Kong%20coastal%20mystery%20series%20poster%20artwork%2C%20a%20waterproof%20evidence%20case%20wedged%20in%20black%20rocks%20at%20low%20tide%2C%20moonlit%20sea%20and%20distant%20harbor%20lights%2C%20deep%20teal%20and%20amber%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-29&orientation=portrait',
  },
  {
    id: 'series-30',
    category: 'tv',
    title: '明日之前',
    subtitle: 'Before Tomorrow',
    year: 2024,
    region: '中国台湾',
    genres: ['剧情', '爱情'],
    rating: 8.5,
    director: '蔡明轩',
    cast: ['张书妍', '林柏均', '陈以安'],
    duration: '全12集',
    popularity: 71,
    summary: '一场台风登陆前的十二小时，五个台北人做了五个改变人生的决定。',
    synopsis:
      '强烈台风将在十二小时后登陆台北。五个互不相识的人在这半天里各自做出一个决定：辞职、告白、原谅、离开、回头。剧集用五条平行的时间线讲述同一段午后，随着风雨逼近，他们的路径在一间便利店门口短暂交汇。天亮之后，城市恢复原样，人却不一样了。',
    poster:
      'https://readdy.ai/api/search-image?query=Taipei%20rainy%20drama%20series%20poster%20artwork%2C%20a%20convenience%20store%20glowing%20on%20a%20stormy%20night%20street%2C%20people%20with%20umbrellas%20passing%2C%20warm%20interior%20light%20against%20deep%20blue%20rain%2C%20no%20text%2C%20vertical%20composition&width=480&height=720&seq=poster-series-30&orientation=portrait',
  },
];